import { Button, ButtonProps } from '@commenda/kakashi';
import { cn } from '@commenda/utils';
import React from 'react';

export const ServiceRequestTaskButton = React.forwardRef<
  HTMLButtonElement,
  ButtonProps
>(({ size = 'sm', className, ...props }, ref) => {
  return (
    <Button
      ref={ref}
      size={size}
      className={cn('flex items-center gap-2', className)}
      {...props}
    />
  );
});
